<!-- 商品管理 V2 详情 - SKU 属性人工编辑弹窗 -->
<template>
  <el-dialog
    title="属性编辑表单"
    :visible.sync="visible"
    width="600px"
    append-to-body
    custom-class="sku-edit-dialog"
  >
    <div class="sku-editor">
      <div class="editor-head">
        <el-button type="primary" size="small" @click="addSku">人工编辑属性</el-button>
        <button type="button" class="add-button" @click="addSku"><i class="el-icon-plus"></i></button>
      </div>
      <!-- 属性名 / 属性值 表格 -->
      <div class="sku-table">
        <div class="sku-grid table-head">
          <div>属性名称</div>
          <div>具体属性值</div>
          <div>操作</div>
        </div>
        <div v-for="(sku, index) in list" :key="index" class="sku-grid table-row">
          <div><el-input v-model="sku.key" /></div>
          <div><el-input v-model="sku.value" /></div>
          <div><button type="button" class="delete-button" @click="deleteSku(index)"><i class="el-icon-minus"></i></button></div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm">保存</el-button>
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
/**
 * 商品 base.sku 人工编辑
 * 不依赖链接解析，纯手动维护属性键值对
 */
export default {
  name: 'SkuEditDialog',
  data() {
    return {
      visible: false,
      list: [] // { key, value }[]
    }
  },
  methods: {
    // 打开弹窗，sku 为 null 时从空列表开始
    open(sku) {
      this.list = sku === null ? [] : sku.map(item => ({ key: item.key, value: item.value }))
      this.visible = true
    },
    addSku() {
      this.list.push({ key: '', value: '' })
    },
    deleteSku(index) {
      this.list.splice(index, 1)
    },
    // 回传编辑结果
    confirm() {
      this.$emit('confirm', this.list)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.sku-editor { padding: 4px 8px; }
.editor-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
.add-button,
.delete-button { display: flex; align-items: center; justify-content: center; width: 30px; height: 30px; padding: 0; border: 2px solid #303133; border-radius: 4px; background: #fff; color: #303133; cursor: pointer; }
.add-button i,
.delete-button i { font-size: 20px; font-weight: 700; }
.sku-table { overflow: hidden; border: 1px solid #dcdfe6; border-radius: 4px; }
.sku-grid { display: grid; grid-template-columns: 1fr 1fr 80px; }
.sku-grid > div { box-sizing: border-box; display: flex; align-items: center; justify-content: center; min-width: 0; padding: 6px; border-right: 1px solid #dcdfe6; }
.sku-grid > div:last-child { border-right: 0; }
.table-head { min-height: 42px; background: #edeff4; font-weight: 700; }
.table-row { min-height: 48px; border-top: 1px solid #dcdfe6; }
.table-row .el-input { width: 100%; }
.dialog-footer { display: flex; justify-content: center; gap: 24px; }
.dialog-footer .el-button { width: 126px; margin: 0; }
</style>

<style lang="scss">
.sku-edit-dialog .el-dialog__body { padding: 12px 24px 8px; }
</style>
